import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import styles from './index.less';
import ThirdPageStore from '@src/pages/main/components/third-page/store';
import BaseSwiper from '@src/components/swiper/base-swiper';
import Link from '@src/components/link';
import dayjs from 'dayjs';
import TabMenu from './components/tab-menu';
import { isType } from '@src/utils/common-util';

/**
 * SecondPage
 * @param store {SecondPageStore}
 * @returns {JSX.Element}
 * @constructor
 */

const ThirdPage = ({ store }) => {
  const { layerData = {}, tabsMap, localData = {} } = store;
  store.use();

  const RenderWortPartItem = React.memo(({ item }) => {
    return (
      <div className={styles.worldPart} onClick={() => store.viewDetail(item)}>
        <div className={cx(styles.worldPartItem)}>
          <div data-name="hover样式" className={styles.worldPartHover}>
            <div data-name="左侧光影" className={styles.leftShadow} />
            <div data-name="装饰组" className={styles.decorateGroup}>
              <div className={styles.decorate1} />
              <div className={styles.decorate2} />
              <div className={styles.decorate3} />
            </div>
            <div data-name="右侧|光影叠加层" className={styles.rightShadowGroup}>
              <div className={styles.rightShadow1} />
              <div className={styles.rightShadow2}>
                <img src={require('./images/item-hover/light-shadow-2.png')} alt="" />
              </div>
            </div>
          </div>
          <div className={styles.newsIcon}>
            {tabsMap?.[item.tab_key]?.tab_title_img ? <img className={styles.newsIcon} src={tabsMap[item.tab_key].tab_title_img} alt="" /> : null}
          </div>
          <div className={styles.newsTitle}>{item.title}</div>
          <div className={styles.newsTime}>{dayjs(item.publishedAt * 1000).format('YYYY/MM/DD')}</div>
        </div>
      </div>
    );
  });
  // 缓存新闻列表
  const newsList = React.useMemo(
    () => {
      return store.newsData.map(item => <RenderWortPartItem item={item} key={item.contentId} />);
    },
    [store.newsData]
  );

  const handleSlideClick = e => {
    const target = e.target;
    const item = layerData.article_swipers[target.getAttribute('data-index')];
    item?.contentId && store.viewDetail(item);
  };
  return (
    <div className={cx(styles.root)}>
      <div className={styles.bg}>
        <div className={styles.container}>
          <div className={styles.titleBox}>
            <div className={styles.enTitle} />
            <div className={styles.chTitle} />
          </div>
          <div className={styles.newsLeftBox}>
            <TabMenu store={store.tabMenuStore} className={styles.tabMenu} />
            <div key={store.tab_key} className={styles.listBox}>
              {isType(store.newsData, 'Array') && store.newsData.length ? (
                newsList
              ) : (
                <div className={styles.empty} style={{ backgroundImage: `url(${localData.not_data_tips})` }} />
              )}
            </div>
          </div>
          <div className={styles.newsRightBox}>
            <div className={styles.imgSwiperBox} onClick={handleSlideClick}>
              {layerData.article_swipers.length > 0 && (
                <BaseSwiper className={styles.newImgSwiper} store={store.imgSwiperStore}>
                  {layerData.article_swipers.slice(0, 5).map((item, index) => {
                    return (
                      <div data-index={index} className={cx('mechaTab')} key={index}>
                        <Link className={styles.imgBox} style={{ pointerEvents: 'none' }}>
                          <img src={item?.thumb} alt="新闻图" />
                        </Link>
                      </div>
                    );
                  })}
                </BaseSwiper>
              )}
            </div>
            <div className={styles.paginatorBox}>
              {layerData?.article_swipers.slice(0, 5).map((item, key) => {
                return (
                  <div
                    className={cx(styles.paginatorItem, key === store.imgSwiperStore.activeIndex && styles.paginatorItemActive)}
                    onClick={() => store.imgSwiperStore.onChange(key)}
                    key={key}
                  />
                );
              })}
            </div>
            <Link
              className={styles.btnMore}
              style={{ backgroundImage: `url(${localData.more_buttom_btn})` }}
              onClick={() => {
                store.more();
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default wrapStore(ThirdPage, ThirdPageStore);
